import { graphClient } from '../graph-client'
import type { LiveCheckinMonthLevelReward } from '../../types/check-in'
import type { Response } from '../../types/response'
import {
  CLAIM_LIVE_CHECKIN_MONTH_LEVEL_REWARD,
  GET_LIVE_CHECKINS_MONTHS_LEVELS_REWARDS,
} from './gql'

export namespace GetList {
  export interface Input {
    take?: number
    skip?: number
    liveCheckinMonthId?: number
    userId?: number
    unlocked?: boolean
    received?: boolean
  }
  export interface Output {
    getLiveCheckinsMonthsLevelsRewards: Response<LiveCheckinMonthLevelReward[]>
  }
}

export namespace Claim {
  export interface Input {
    liveCheckinMonthLevelRewardId: number
  }
  export interface Output {
    claimLiveCheckinMonthLevelReward: Response<LiveCheckinMonthLevelReward>
  }
}

class LiveCheckinMonthsLevelsRewardsService {
  async getList(params: GetList.Input) {
    const res = await graphClient.request<GetList.Output>(
      GET_LIVE_CHECKINS_MONTHS_LEVELS_REWARDS,
      params,
    )
    return res?.getLiveCheckinsMonthsLevelsRewards
  }

  async claim(params: Claim.Input) {
    const res = await graphClient.request<Claim.Output>(
      CLAIM_LIVE_CHECKIN_MONTH_LEVEL_REWARD,
      params,
    )
    return res?.claimLiveCheckinMonthLevelReward
  }
}

export const liveCheckinMonthsLevelsRewardsService =
  new LiveCheckinMonthsLevelsRewardsService()
